import React from 'react';
import ReactDOM from 'react-dom/client';
import '../src/assets/css/app.css';
import App from './App';

import { pdfjs } from 'react-pdf';
import workerSrc from 'pdfjs-dist/build/pdf.worker.min.js';

// Configuração global do worker (apenas uma vez)
pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);